import * as React from "react";
const SvgMicrophone01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.965 12v-2a1.035 1.035 0 0 1 2.07 0v2a5.965 5.965 0 1 0 11.93 0v-2a1.035 1.035 0 0 1 2.07 0v2a8.034 8.034 0 0 1-7 7.966v.999H16a1.035 1.035 0 0 1 0 2.07H8a1.035 1.035 0 0 1 0-2.07h2.965v-1a8.034 8.034 0 0 1-7-7.965m10-7a1.965 1.965 0 1 0-3.93 0v7a1.965 1.965 0 1 0 3.93 0zm2.07 7a4.035 4.035 0 0 1-8.07 0V5a4.035 4.035 0 0 1 8.07 0z"
}));
export default SvgMicrophone01;
//# sourceMappingURL=Microphone01.js.map